export default "__VITE_ASSET__BuzDOs6K__"